import React from 'react';
import { SkBox, SkText, SkCircle } from '../../../components/SkeletonLoader/SkeletonLoader';

interface ComplaintDetailSkeletonProps {
    styles: any;
}

const ComplaintDetailSkeleton: React.FC<ComplaintDetailSkeletonProps> = ({ styles }) => {
    return (
        <div className={styles.viewContainer || styles.modalContainer}>
            {/* Header Skeleton */}
            <div className={styles.pageHeaderSection || styles.highlightSection}>
                <div className={styles.headerMainArea || styles.highlightHeader}>
                    <div className={styles.headerTitleRow || styles.headerTopRow}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 }}>
                            <SkBox width={60} height={14} />
                            <SkBox width="40%" height={32} />
                        </div>
                        <SkBox width={100} height={28} borderRadius={20} />
                    </div>

                    <div className={styles.headerMetaGrid || styles.subtitleRow}>
                        {[1, 2, 3].map((i) => (
                            <div key={i} className={styles.metaBlock || styles.idBadge}>
                                <SkBox width={70} height={12} style={{ marginBottom: '8px' }} />
                                <SkBox width={120} height={18} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Tab Bar Skeleton - Only if present in classes */}
            {styles.tabBar && (
                <div className={styles.tabBar}>
                    <SkBox width={140} height={40} borderRadius={8} style={{ marginRight: '12px' }} />
                    <SkBox width={160} height={40} borderRadius={8} />
                </div>
            )}

            {/* Content Body Skeleton */}
            <div className={styles.contentSection}>
                <div className={styles.tabContentArea || ''}>
                    {/* Info Card Skeleton */}
                    <div className={styles.infoCard}>
                        <div className={styles.cardHeader}>
                            <SkCircle width={20} height={20} style={{ marginRight: '10px' }} />
                            <SkBox width={150} height={20} />
                        </div>
                        <div className={styles.cardContentGrid}>
                            {[1, 2, 3, 4].map((i) => (
                                <div key={i} className={styles.miniGroup}>
                                    <SkBox width={100} height={12} style={{ marginBottom: '8px' }} />
                                    <SkBox width="80%" height={16} />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Items Section Skeleton */}
                    <div className={styles.itemsSection}>
                        <div className={styles.itemsHeader}>
                            <SkBox width={200} height={24} />
                            <SkBox width={180} height={32} />
                        </div>
                        <div className={styles.tableContainer}>
                            <div className={styles.tableHeaderRow}>
                                <div style={{ flex: 1 }}><SkBox width={80} height={14} /></div>
                                <div style={{ flex: 2 }}><SkBox width={80} height={14} /></div>
                                <div style={{ flex: 1 }}><SkBox width={80} height={14} /></div>
                            </div>
                            <div className={styles.tableBody}>
                                {[1, 2].map((i) => (
                                    <div key={i} className={styles.tableRow}>
                                        <div style={{ flex: 1 }}><SkBox width={80} height={24} borderRadius={4} /></div>
                                        <div style={{ flex: 2 }}>
                                            <SkBox width="90%" height={18} style={{ marginBottom: '8px' }} />
                                            <SkBox width="60%" height={14} />
                                        </div>
                                        <div style={{ flex: 1 }}><SkBox width={40} height={24} /></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComplaintDetailSkeleton;
